import React from "react";
import {
  Box,
  Heading,
  Text,
  Center,
  Icon,
  Button,
  SimpleGrid,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { PiVideoConference } from "react-icons/pi";

const VideoConferencing = () => {
  // -----------------------------
  // 1) (No local state)
  // -----------------------------

  // -----------------------------
  // 2) Color definitions
  // -----------------------------
  const containerBg = useColorModeValue("gray.50", "gray.800");
  const headingColor = useColorModeValue("primary.700", "primary.500");
  const iconColor = useColorModeValue("primary.500", "primary.500");
  const textColor = useColorModeValue("gray.600", "gray.200");
  const subHeadingColor = useColorModeValue("primary.600", "primary.500");
  const dividerColor = useColorModeValue("gray.200", "gray.600");

  // -----------------------------
  // 3) JSX
  // -----------------------------
  return (
    <Box
      bg={containerBg}
      w="100%"
      minH="100vh"
      p={5}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Center w="100%" flexDirection="column">
        <Icon as={PiVideoConference} boxSize={20} color={iconColor} mb={4} />
        <Heading as="h1" size="2xl" color={headingColor} textAlign="center">
          Video Conferencing Module Coming Soon
        </Heading>
        <Text
          fontSize="lg"
          color={textColor}
          textAlign="center"
          maxW="800px"
          mt={4}
        >
          We&apos;re thrilled to announce that our new Video Conferencing
          Module is on the horizon! Soon, you&apos;ll be able to host and
          join meetings directly from your client portal.
        </Text>
        <Button colorScheme="primary" size="lg" mt={6} disabled>
          Notify Me When Available
        </Button>
      </Center>

      <Divider my={10} borderColor={dividerColor} />

      {/* Feature Highlights */}
      <Box maxW="800px" mx="auto">
        <Heading
          as="h2"
          size="lg"
          color={subHeadingColor}
          mb={4}
          textAlign="center"
        >
          Upcoming Features
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              🎥 High-Quality Video Calls
            </Heading>
            <Text color={textColor}>
              Experience seamless video meetings with HD quality and low latency.
            </Text>
          </Box>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              👥 Group Meetings
            </Heading>
            <Text color={textColor}>
              Host meetings with multiple participants, perfect for team collaborations.
            </Text>
          </Box>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              💻 Screen Sharing
            </Heading>
            <Text color={textColor}>
              Share your screen or specific applications for presentations and
              demonstrations.
            </Text>
          </Box>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              📋 Meeting Recording
            </Heading>
            <Text color={textColor}>
              Record your meetings and access them later for reference or sharing.
            </Text>
          </Box>
        </SimpleGrid>
      </Box>
      <Box w="10px" h="100px" />
    </Box>
  );
};

export default VideoConferencing;
